import React, { useState } from 'react';
import Spinner from './Global/Spinner';
import client from '../api/client';
import { useUser } from '../context/UserContext';
export default function GenerateBlogPost({ color = '', ...rest }) {
	const [loading, setLoading] = useState(false);
	const { user } = useUser();
	const generate = async (e) => {
		try {
			e.preventDefault();
			setLoading(true);
			const { data } = await client.get('/blog/generate_post', {
				headers: {
					'Content-Type': 'application/json',
				},
			});
			setLoading(false);
			if (data) {
				console.log({ data });
				return;
			}
		} catch (error) {
			setLoading(false);
			return console.error(error);
		}
	};
	if (loading) return <Spinner color='white' />;
	if (user && user.isAdmin) {
		return (
			<button
				onClick={generate}
				{...rest}
			>
				Generate Blog Post
			</button>
		);
	}
}
